import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.7",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5 10.5 7.2 4l3 3.8L13.8 4l2.2 6.5M5.2 12.2c.4 5 4 7.3 6.8 7.3s6.4-2.3 6.8-7.3" }, null, -1),
    _createElementVNode("circle", {
      cx: "9.2",
      cy: "13",
      r: "1",
      fill: "currentColor",
      stroke: "none"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "14.8",
      cy: "13",
      r: "1",
      fill: "currentColor",
      stroke: "none"
    }, null, -1),
    _createElementVNode("path", { d: "M10.2 16.2c1.2.8 2.4.8 3.6 0" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clinic-feature-catfriendly"}) } }